// src/types/shared/EntityStatus.ts

/**
 * Standard status states for all entities that support soft delete
 */
export type EntityStatus = 'active' | 'inactive' | 'archived';

/**
 * Enum for entity status values
 */
export const EntityStatusEnum = {
  Active: 'active',
  Inactive: 'inactive',
  Archived: 'archived'
} as const;

/**
 * Type guard to check if entity is active
 */
export const isEntityActive = (status: EntityStatus): boolean => {
  return status === EntityStatusEnum.Active;
};

/**
 * Type guard to check if entity should be visible in normal views
 */
export const isEntityVisible = (status: EntityStatus): boolean => {
  return status === EntityStatusEnum.Active || status === EntityStatusEnum.Inactive;
};